import { Navigate, createBrowserRouter } from "react-router-dom";
import { Admin, AdminRedirect, Main, Public, Redirect } from "~/layouts";
import Login from "~/routes/login";

const router = createBrowserRouter([
    {
        path: "/me/:installation/:company",
        element: <Main />,
        children: [
            {
                index: true,
                element: <Navigate to="dashboard" replace />,
            },
            {
                path: "dashboard",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/dashboard"
                    );
                    return { Component };
                },
            },
            {
                path: "archive",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/archive"
                    );
                    return { Component };
                },
            },
            {
                path: "admin",
                element: <Admin />,
                children: [
                    {
                        index: true,
                        element: <AdminRedirect />,
                    },
                    {
                        path: "time",
                        async lazy() {
                            const { default: Component } = await import(
                                "~/routes/admin-time"
                            );
                            return { Component };
                        },
                    },
                    {
                        path: "approval",
                        async lazy() {
                            const { default: Component } = await import(
                                "~/routes/admin-approval"
                            );
                            return { Component };
                        },
                    },
                    {
                        path: "expenses",
                        async lazy() {
                            const { default: Component } = await import(
                                "~/routes/admin-expenses"
                            );
                            return { Component };
                        },
                    },
                    {
                        path: "tasks",
                        async lazy() {
                            const { default: Component } = await import(
                                "~/routes/admin-tasks"
                            );
                            return { Component };
                        },
                    },
                ],
            },
            {
                path: "projects",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/projects"
                    );
                    return { Component };
                },
            },
            {
                path: "projects/:project/:tab?",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/project"
                    );
                    return { Component };
                },
            },
            {
                path: "resources/:tab?",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/resources"
                    );
                    return { Component };
                },
            },
            {
                path: "chat",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/chat"
                    );
                    return { Component };
                },
            },
            {
                path: "settings",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/settings"
                    );
                    return { Component };
                },
            },
            {
                path: "profile",
                async lazy() {
                    const { default: Component } = await import(
                        "~/routes/profile"
                    );
                    return { Component };
                },
            },
        ],
    },
    {
        path: "/p",
        element: <Public />,
        children: [
            { index: true, element: <Navigate to="/p/login" replace /> },
            {
                path: "login",
                element: <Login />,
            },
        ],
    },
    {
        path: "*",
        element: <Redirect />,
    },
]);

export default router;
